export const CustomerParties = [
  { key: "partyPhone", value: "ارتباط با تلفن" },
  { key: "partyAddress", value: "ارتباط با آدرس" },
];
